export default __webpack_public_path__ + "static/media/pin_bg.e3c56721.jpg";